import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { createCustomElement } from '@angular/elements';
import { provideHttpClient } from '@angular/common/http';

import { environment } from './environments/environment';
import { BeeasyChatComponent } from './app/layout/components/chat/chat.component';

import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getStorage } from 'firebase/storage';
import { provideStorage } from '@angular/fire/storage';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, Routes } from '@angular/router';

if (environment.production) {
  enableProdMode();
}

const routes: Routes = [
  // { path: ':conversationId', component: BeeasyChatComponent },
  {
    path: '',
    component: BeeasyChatComponent
  },
  {
   path: '**',
    redirectTo: '',
  },
];

bootstrapApplication(BeeasyChatComponent, {
  providers: [
    provideHttpClient(),
    // provideRouter(routes),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideFirestore(() => getFirestore()),
    provideAuth(() => getAuth()),
    provideStorage(() => getStorage()),
    provideAnimations(),
  ]
})
  .then(appRef => {
    const el = createCustomElement(BeeasyChatComponent, {
      injector: appRef.injector
    });

    if (!customElements.get('chat-widget')) {
      customElements.define('chat-widget', el);
    }
  })
  .catch(err => console.error(err));
